import React from 'react'
import ReactDOM from 'react-dom'
import App from './modules/app/App'
import './modules/app/sentry'
import reportWebVitals from './reportWebVitals'

// Polyfill needed for hardware wallet modules
import { Buffer } from 'buffer'
import { applyTheme } from './theme/utils'

window.Buffer = Buffer

if (window.ethereum) {
    window.ethereum.autoRefreshOnNetworkChange = false
}

applyTheme()

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
)

reportWebVitals()
